// Description: Policy Editor functionality.
//
//TODO: Refactor to use ES6 syntax and functions.

function setupPolicyEditor() {
    const elementFields = document.querySelectorAll(".js-policy-element");
    elementFields.forEach(addPolicyElementEventListeners);
}

function editorLoad(editor) {
    let contentAreaEl = editor.get_contentAreaElement();
    contentAreaEl.removeAttribute("title");
    fixRadEditorHeight(editor);
    editor.get_toolContainer().parentElement.style.height = '5px';
}

function addPolicyElementEventListeners(element) {
    let policyRadEditorFields = element.querySelectorAll(".js-policy-text-section");
    let policyReplacerTags = element.querySelectorAll(".replacer-tag");
    element.addEventListener('mouseover', event => {
        toggleElementHover(element, true);
    });
    element.addEventListener('mouseout', event => {
        toggleElementHover(element, false);
    });
    element.addEventListener('click', event => {
        toggleElementFocus(element, true);
    });
    document.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(element);
        if (withinBoundaries) {
            toggleElementFocus(element, true);
        } else {
            toggleElementFocus(element, false);
        }
    });
    policyRadEditorFields.forEach(policyRadEditorField => policyRadEditorField.addEventListener('click', event => {
        if (document.activeElement === policyRadEditorField.querySelector('.reContentArea')) {
            toggleElementFocus(element, true);
        }
    }));
    policyReplacerTags.forEach(policyReplacerTag => {
        policyReplacerTag.onselectstart = preventTextSelect;
        addPolicyReplacerEvents(policyReplacerTag);
    });
}

function addPolicyRadEditorEvents(editor, args) {
    let element = editor.get_contentArea();
    let childElements = element.getElementsByTagName('p');
    addPolicyDragDropEvents(element);
    childElements.forEach(addPolicyDragDropEvents(element));
}

function addPolicyReplacerEvents(element) {
    //element.addEventListener('mousedown', preventTextSelect);
    // TODO - fix below for replacer tag drag and drop
    //element.addEventListener('mousedown', dragStart(event));
}

function addPolicyDragDropEvents(element) {
    element.addEventListener('dragenter', dragEnter)
    element.addEventListener('dragover', dragOver);
    element.addEventListener('dragleave', dragLeave);
    element.addEventListener('drop', drop);
}

function preventTextSelect() {
    return false;
}

//function renderReplacerTag(node) {
//    const textNode = document.createTextNode('Some Text');
//    const tagSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
//    const tagPath = document.createElementNS(
//        'http://www.w3.org/2000/svg',
//        'text'
//    );
//    tagSvg.setAttribute('height', '30');
//    tagSvg.setAttribute('width', '200');
//    tagPath.setAttribute('x', '30');
//    tagPath.setAttribute('y', '30');
//    tagPath.setAttribute('fill', 'black');
//    tagPath.appendChild(textNode);

//    tagSvg.appendChild(tagPath);

//    return node.appendChild(tagSvg);
//}

function dragStart(e) {
    e.dataTransfer.setData('text/html', e.target.outerHTML);
}

function drop(e) {
    e.preventDefault();
    var data = e.dataTransfer.getData("text/html");
    pasteHtmlAtCaret(data);
}

function dragEnter(e) {
    e.preventDefault();
    e.target.classList.add('drag-over');
}

function dragOver(e) {
    e.target.classList.add('drag-over');
}

function dragLeave(e) {
    e.target.classList.remove('drag-over');
}

function pasteHtmlAtCaret(html) {
    let sel, range;
    sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        let el = document.createElement("div");
        el.innerHTML = html;
        let frag = document.createDocumentFragment();
        frag.appendChild(el.firstChild)
        range.insertNode(frag);
    }
}